
<form [formGroup]="financingSources" id="financing-sources" (ngSubmit)=onSubmit(financingSources)>
	<div class="d-flex flex-column justify-content-center text-center flex-column m-step-wrapper container" [ngClass]="{'first-question' : !prevQID}">
		<questions-manager [(editQid)]="qID" [visibleQids]="visibleQids" [(editQuestion)]="editQuestion" (editQuestionChange)="editQuestionChange($event)">

			<question [qID]="'1'">
				<h3>{{"FINANCING_SOURCES.QUESTION1.QUESTION"|translate}}</h3>
				<div class="btn-group-toggle" data-toggle="buttons">
					<label class="btn btn-primary" 
					[ngClass]="{'selected':financingSources.get('haveMoreLoan').value==='YES'}">
						{{"COMMON.YES"|translate}}
						<input type="radio" formControlName="haveMoreLoan" value="YES" 
						(change)="onSubmit(financingSources)" click2change>
					</label>
					<label class="btn btn-primary" 
					[ngClass]="{'selected':financingSources.get('haveMoreLoan').value==='NO'}">
						{{"COMMON.NO"|translate}}
						<input type="radio" formControlName="haveMoreLoan" value="NO" (change)="onSubmit(financingSources)" click2change>
					</label>
				</div>
			</question>
			
			<question [qID]="'2'">
                <div>
                    <h3>{{"FINANCING_SOURCES.QUESTION2.QUESTION"|translate}}</h3>
                    <div class="form-group">
							<input type="text" 
							formControlName="loanPropose" 
                            placeholder="{{'FINANCING_SOURCES.QUESTION2.PH1'|translate}}"
							class="form-control m-form-control" 
							[attr.aria-label]="'FINANCING_SOURCES.Q2.PH1'|translate"/>
                            <div class="form-text m-error" 
                            *ngIf="financingSources.get('loanPropose').hasError('pattern') && submitted">
                                {{ 'COMMON.GENERAL_PATTERN_ERROR' | translate }}
							</div>
							<div class="form-text m-error" 
							*ngIf="financingSources.get('loanPropose').hasError('required') && submitted">
							{{ 'COMMON.FIELD_REQUIRED' | translate }}
						</div>
                    </div>
                    <div class="d-flex justify-content-center">
                        <button type="submit" class="btn btn-primary" 
                                [ngClass]="{'m-valid' : financingSources.valid && qID=='2'}">
                                {{"COMMON.PROCEED"|translate}}
                        </button>
                    </div>
                </div>
                					
			</question>
		
			<question [qID]="'3'">
				<div>
					<h3>{{"FINANCING_SOURCES.QUESTION3.QUESTION"|translate}}</h3>
					<div class="mx-1 form-group">
						<input formControlName="loanAmount" 
						class="m-form-control form-control" 
						currencyMask type="tel" 
						placeholder="{{'FINANCING_SOURCES.QUESTION3.PH1'|translate}}">
						<div class="form-text m-error" 
						*ngIf="financingSources.get('loanAmount').hasError('required') && submitted">
							{{ 'COMMON.FIELD_REQUIRED' | translate }}
						</div>
					</div>
				</div>
				<div class="d-flex justify-content-center">
					<button type="submit" class="btn btn-primary"  
					(click)="onSubmit(financingSources)" 
					[ngClass]="{'m-valid' : financingSources.valid && qID=='3'}">{{"COMMON.PROCEED"|translate}}</button>
				</div>
			</question>
		</questions-manager>
	</div>
</form>


// WEBPACK FOOTER //
// ./src/app/financing-sources/financing-sources.component.html